// extracted by mini-css-extract-plugin
export default {"phone":"MessageViewer_phone__nPT79","created":"MessageViewer_created__aRIui","sms":"MessageViewer_sms__Bps84"};